export const FILTER1 = [
  "All specialities",
  "Spine",
  "Trauma",
  "Ortho",
  "Dental"
];

export const FILTER2 = [
  "All sections",
  "Case study",
  "Product information",
  "Abstract summary"
];

export const FILTER3 = ["All audiences", "Physics", "Chemists"];

export const ARTICLES_PER_PAGE = [3, 9, 36];



// WEBPACK FOOTER //
// ./src/constants/fiters.js